import { render, staticRenderFns } from "./tenderTable.vue?vue&type=template&id=4b77a15f&scoped=true&"
import script from "./tenderTable.vue?vue&type=script&lang=js&"
export * from "./tenderTable.vue?vue&type=script&lang=js&"
import style0 from "./tenderTable.vue?vue&type=style&index=0&id=4b77a15f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b77a15f",
  null
  
)

export default component.exports